import { render, staticRenderFns } from "./betParlayModal.vue?vue&type=template&id=48632d86&lang=pug&"
import script from "./betParlayModal.vue?vue&type=script&lang=js&"
export * from "./betParlayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports